import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';

import Landing from './screens/Landing.jsx';
import Pricing from './screens/Pricing.jsx';
import Sample from './screens/Sample.jsx';
import Signup from './screens/Signup.jsx';
import Verify from './screens/Verify.jsx';
import WorkspaceSetup from './screens/WorkspaceSetup.jsx';
import Docs from './screens/Docs.jsx';
import Coverage from './screens/Coverage.jsx';
import Status from './screens/Status.jsx';
import Dashboard from './screens/Dashboard.jsx';
import ConsoleLayout from './screens/console/Layout.jsx';
import Overview from './screens/console/Overview.jsx';
import Watchlists from './screens/console/Watchlists.jsx';
import Webhooks from './screens/console/Webhooks.jsx';
import ApiKeysScreen from './screens/console/ApiKeys.jsx';
import BillingScreen from './screens/console/Billing.jsx';
import SettingsScreen from './screens/console/SettingsScreen.jsx';
import AuthGuard from './components/AuthGuard.jsx';
import { applyTheme, getInitialTheme } from './theme/index.js';

export default function App() {
  // resolve + apply theme once at mount; useTheme inside Landing keeps it
  // in sync if the user clicks the picker.
  useEffect(() => {
    applyTheme(getInitialTheme());
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/sample" element={<Sample />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/verify" element={<Verify />} />
        <Route
          path="/workspace-setup"
          element={
            <AuthGuard>
              <WorkspaceSetup />
            </AuthGuard>
          }
        />
        <Route path="/docs" element={<Docs />} />
        <Route path="/coverage" element={<Coverage />} />
        <Route path="/status" element={<Status />} />
        <Route
          path="/dashboard"
          element={
            <AuthGuard requireWorkspace>
              <Dashboard />
            </AuthGuard>
          }
        />
        <Route
          path="/console"
          element={
            <AuthGuard requireWorkspace>
              <ConsoleLayout />
            </AuthGuard>
          }
        >
          <Route index element={<Navigate to="/console/overview" replace />} />
          <Route path="overview" element={<Overview />} />
          <Route path="watchlists" element={<Watchlists />} />
          <Route path="webhooks" element={<Webhooks />} />
          <Route path="keys" element={<ApiKeysScreen />} />
          <Route path="billing" element={<BillingScreen />} />
          <Route path="settings" element={<SettingsScreen />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
